export const APPLICATION_PDF = 'application/pdf'

// export const BASE_URL = 'http://localhost:8080'; // -> for local testing only...
export const BASE_URL = '/';
export const FETCH_ROLES = '/v1/roles';
export const FETCH_ROLES_BY_LOAN = '/v1/roles/loan';
export const FETCH_EXTERNAL_USERS = '/v1/externalUsers';
export const EXTERNAL_ORGANIZATION_API = '/v1/external-organization';
export const PERSIST_ROLE_ASSIGNMENT = '/v1/roleAssignment';
export const POST_EXTERNAL_ORGANIZATION = '/v1/external-organization';
export const FETCH_TOKEN ='/v1/auth/getToken'

export interface CompanyOptions {
  readonly value: string;
  readonly label: string;
}
export const companyOptions: readonly CompanyOptions[] = [
  { value: 'globexlending', label: 'Globex Lending' },
  { value: 'mortgagecorp', label: 'MortgageCorp'},
  { value: 'acmelight', label: 'Acme Light'},
];
